import VParallax from './VParallax'

export default {
  VParallax
}



// WEBPACK FOOTER //
// ./src/components/parallax/index.js